import { ReactNode } from 'react';

/*
 * Action Types
 */
export enum DialogsTypes {
  SET_OPEN = '@dialogs/SET_OPEN',
  SET_CLOSE = '@dialogs/SET_CLOSE',
  SET_SECOND_OPEN = '@dialogs/SET_SECOND_OPEN',
  SET_SECOND_CLOSE = '@dialogs/SET_SECOND_CLOSE',
  IS_LOADING = '@isLoading/IS_LOADING',
}

/*
 * Data types
 */
export interface Dialog {
  open: boolean;
  isDialogPrint?: boolean;
  content?: ReactNode;
  propsDialog?: any;
  wasCalled?: boolean;
  onClose?: () => void;
  disableBackdropClick?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/*
 * State type
 */
export interface DialogsState {
  readonly dialog: Dialog;
  readonly secondDialog: Dialog;
  readonly isLoading?: boolean;
}
